import { TransparentButton } from '@libs/components';
import { ResultFeedbackType } from 'src/constants';
import styled, { css } from 'styled-components';

export const ToastStyles = {
  [ResultFeedbackType.SUCCESS]: css`
    background-color: ${({ theme }) => theme.colors.text.success};
  `,
  [ResultFeedbackType.ERROR]: css`
    background-color: ${({ theme }) => theme.colors.text.critical};
  `,
  [ResultFeedbackType.PENDING]: css`
    background-color: ${({ theme }) => theme.colors.text.pending};
  `,
  [ResultFeedbackType.WARNING]: css`
    background-color: ${({ theme }) => theme.colors.text.pending};
  `,
};
export const Container = styled.div`
  padding: 0, 2.8rem;
  width: 100%;
`;

type ToastMainContainerProps = {
  type?: ResultFeedbackType;
};

export const MainContainer = styled.div<ToastMainContainerProps>`
  flex: 1;
  padding: 2rem, 1.6rem;

  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme, type }) =>
    type ? ToastStyles[type] : theme.colors.text.success};
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  width: 100%;
`;
export const IconWrapper = styled.div`
  margin-right: 0.8rem;
  max-width: 2.5rem;
  height: 2.5rem;
`;

export const Img = styled.img`
  margin-right: 0.8rem;
  max-width: 2.5rem;
  height: 2.5rem;
`;

export const CloseIconWrapper = styled.div`
  margin-left: 0.4rem;
`;

export const TextContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CloseButtonContainer = styled(TransparentButton)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
`;
